import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export const Hero = () => {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden" data-id="element-43">
      {/* Background glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-neon/5 rounded-full blur-[120px] pointer-events-none" data-id="element-44" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-45">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-46">
          <div className="flex-1 text-center lg:text-left" data-id="element-47">
            <FadeIn data-id="element-48">
              <h1 className="text-4xl md:text-5xl lg:text-6xl leading-[1.1] mb-6" data-id="element-49">
                ¿Necesitas <span className="text-neon" data-id="element-50">dinero extra</span> esta
                semana y no sabes por dónde empezar?
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-51">
              <h2 className="text-lg md:text-xl text-gray-400 font-sans font-medium mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-52">
                El plan paso a paso para activar ingresos adicionales en 48
                horas usando lo que ya tienes y sabes hacer. Sin buscar empleo.
                Sin entrevistas. Sin experiencia previa.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-53">
              <div className="flex flex-col items-center lg:items-start gap-4" data-id="element-54">
                <Button className="w-full sm:w-auto" showIcon={false} onClick={() => {
                document.getElementById('precio-final')?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                });
              }} data-id="element-55">
                  ⚡ QUIERO EL PLAN DE EMERGENCIA AHORA
                </Button>

                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-3 gap-y-2 text-sm text-gray-400 mt-2" data-id="element-56">
                  <span data-id="element-57">🕐 Acceso instantáneo</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-58" />
                  <span data-id="element-59">✅ Pago seguro</span>
                  <span className="w-1 h-1 rounded-full bg-gray-600" data-id="element-60" />
                  <span data-id="element-61">📥 Descarga inmediata</span>
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none" data-id="element-62">
            <FadeIn direction="left" delay={0.3} data-id="element-63">
              <motion.div animate={{
              y: [-10, 10, -10]
            }} transition={{
              duration: 6,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="relative" data-id="element-64">
                <div className="absolute inset-0 bg-neon/20 blur-[60px] rounded-full" data-id="element-65" />
                <img src="https://cdn.magicpatterns.com/uploads/i98tbdWAFmDMydmCtG4nes/efectivo_inmediato_48_horas.png" alt="Plan de Emergencia Financiera de 48 Horas" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-66" />
              </motion.div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};